import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../../context/auth';
import moment from 'moment';
import { Col, Row, Button, Card } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

//API
import tipoDeFiscalizacao_api from '../../../../api/tipoDeFIscalizacao_api';
import relatorio_api from '../../../../api/relatorio_api';

//Helpers
import { showMessage } from '../../../../helpers/message';
import { objCampo, validarCampos, validarData, isDateOverflow } from '../../../../helpers/ValidadorDeCampos';
import { criarOnChangeMultiSelect } from '../../../../helpers/onChangeMultiSelect';
import mascaras from '../../../../helpers/mascaras';

//Components
import TextField from '../../../../components/TextField';
import RelatorioDividaAtiva from './RelatorioDividaAtiva';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';


function initialStateFiltroDividaAtiva() {
  const dataInicial = new Date();
  dataInicial.setMonth(dataInicial.getMonth() - 1);

  return {
    tipoBusca: 'Data de Infração',
    dataInicial: moment(dataInicial).format("YYYY-MM-DD"),
    dataFinal: moment(new Date()).format("YYYY-MM-DD"),
    tipoFiscalizacao_Ids: [],
    tipoFiscalizacao_Descricao: "",
    numeroInfracao: "",
    logradouro: '',
    numero: '',
    bairro: '',
    nome: '',
    situacaoDividaAtiva: "Todos"
  }
}
export default function DividaAtivaRelatorio() {
  //State para consultar Divida Ativa
  const [filtroDividaAtiva, setFiltroDividaAtiva] = useState(initialStateFiltroDividaAtiva());

  //State para pegar lista dos tipos de fiscalizacao
  const [listTipoDeFiscalizacao, setListTipoDeFiscalizacao] = useState([]);

  //State para cards
  const [listaDividaAtiva, setListaDividaAtiva] = useState([]);

  //Estado de controle dos campos de erro
  const [errors, setErrors] = useState({});

  const { setLoading } = useAuth();

  const navigate = useNavigate();

  const datatipoBusca = [
    { value: "Data de Infração", label: "Data de Infração" },
    { value: "Data do Boleto", label: "Data do Boleto" },
    { value: "Vencimento do Boleto", label: "Vencimento do Boleto" },
  ];

  const dataSituacaoDividaAtiva = [
    { value: "Todos", label: "Todos" },
    { value: "Não Inscrito", label: "Não Inscrito" },
    { value: "Inscrito", label: "Inscrito" },
    { value: "Baixa", label: "Baixa" },
  ]

  //Estado de controle dos campos obrigatorios 
  const [campos, setCampos] = useState([
    objCampo({ name: "tipoBusca", required: true }),
    objCampo({ name: "tipoFiscalizacao_Ids", required: true }),
    objCampo({ name: "situacaoDividaAtiva", required: true }),
  ]);

  const loadTipoDeFiscalizacao = () => {
    setLoading(true);
    tipoDeFiscalizacao_api.getList()
      .then(response => {
        response.data.map(value => {
          value.value = value.id;
          value.label = value.identificacao;
          return value;
        })
        setListTipoDeFiscalizacao(response.data)
      })
      .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
      .finally(() => setLoading(false));
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setFiltroDividaAtiva({
      ...filtroDividaAtiva,
      [name]: value
    })
  }

  const onChangeMultiSelectDividaAtiva = criarOnChangeMultiSelect({
    state: filtroDividaAtiva,
    setState: setFiltroDividaAtiva,
    campos,
    errors,
    setErrors
  });

  const onChangeDividaAtiva = (value, e) => {
    const _filtroDividaAtiva = {
      ...filtroDividaAtiva,
      [e.name]: value ? value.value.toString() : null,
    };

    //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
    const _campos = campos.filter(campo => campo.name === e.name);
    const fieldError = validarCampos(_filtroDividaAtiva, _campos);

    const _errors = { ...errors };
    delete _errors[e.name];
    if (fieldError[1].length === 0)
      setErrors({ ..._errors });
    else
      setErrors({ ..._errors, ...fieldError[0] });

    setFiltroDividaAtiva(_filtroDividaAtiva);
  }


  const handleFiltroDividaAtiva = () => {
    //Realizando a validação dos campos obrigatorios
    const _errors = validarCampos(filtroDividaAtiva, campos);
    setErrors(_errors[0]);

    if (_errors[1].length > 0)
      return true;

    //Data Inicial/Final são opcionais quando Nome do Infrator, Número da Infração ou Endereço forem informados
    const possuiFiltroAlternativo = !!(filtroDividaAtiva.nome?.trim() || filtroDividaAtiva.numeroInfracao?.trim() ||
      filtroDividaAtiva.logradouro?.trim() || filtroDividaAtiva.bairro?.trim() || filtroDividaAtiva.numero?.trim());

    if (!possuiFiltroAlternativo && (!filtroDividaAtiva.dataInicial || !filtroDividaAtiva.dataFinal)) {
      return showMessage("Aviso", "Informe o período de datas ou ao menos um dos filtros: Nome do Infrator, Número da Infração ou Endereço.", "warning", null);
    }

    if (filtroDividaAtiva.dataInicial && !validarData(filtroDividaAtiva.dataInicial)) {
      return showMessage(
        "Aviso",
        `A data início informada não é válida. Verifique o valor informado no calendário.`,
        "warning",
        null
      );
    }
    if (filtroDividaAtiva.dataFinal && !validarData(filtroDividaAtiva.dataFinal)) {
      return showMessage(
        "Aviso",
        `A data final informada não é válida. Verifique o valor informado no calendário.`,
        "warning",
        null
      );
    }

    if (filtroDividaAtiva.dataInicial && filtroDividaAtiva.dataFinal &&
      isDateOverflow(filtroDividaAtiva.dataInicial, filtroDividaAtiva.dataFinal, 12, 'months')) {
      return showMessage("Aviso", "A pesquisa deve ter um período máximo de 12 meses!", "warning", null);
    }

    setFiltroDividaAtiva({
      ...filtroDividaAtiva,
      tipoFiscalizacao_Descricao: listTipoDeFiscalizacao
        .filter(value => (filtroDividaAtiva.tipoFiscalizacao_Ids ?? []).includes(value.value))
        .map(value => value.label)
        .join(", ")
    });

    setLoading(true);
    relatorio_api.RelatorioDividaAtiva(filtroDividaAtiva)
      .then(response => {
        response.data = response.data?.map(value => {
          value.documentoInfrator = mascaras.cpfcnpjMask(value.documentoInfrator);
          return value
        })
        setListaDividaAtiva(response.data)
      })
      .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
      .finally(() => setLoading(false));
  }

  const handleVoltar = () => {
    setListaDividaAtiva([]);
  }

  useEffect(() => {
    loadTipoDeFiscalizacao();
  }, []);

  if (listaDividaAtiva.length > 0) {
    return <RelatorioDividaAtiva
      handleVoltar={handleVoltar}
      listaDividaAtiva={listaDividaAtiva}
      filtros={filtroDividaAtiva}
    />
  }

  return <Card className='shadowFicha mainContainerFicha p-4'>
    <div className='mb-3'>
      <Button color='secondary' className='text-white' onClick={() => navigate(-1)}>
        <FontAwesomeIcon icon={faArrowLeft} />
        <span className='px-2'> Voltar </span>
      </Button>
    </div>
    <h4 className='text-secondary m-0'>Dívida Ativa e CADIN</h4>
    <Row className='mt-3'>
      <Col md={12} lg={3}>
        <TextField
          type={"select"}
          name={"tipoBusca"}
          label={"* Tipo de Busca"}
          searchable
          options={datatipoBusca}
          onChange={onChangeDividaAtiva}
          value={
            datatipoBusca.filter(value => value.value == filtroDividaAtiva.tipoBusca)
              .map(v => { return { value: v.value, label: v.value } })
          }
          invalid={!!errors.tipoBusca}
        />
      </Col>
      <Col md={12} lg={3}>
        <TextField
          type={"select"}
          name={"situacaoDividaAtiva"}
          label={"* Situação Divida Ativa"}
          searchable
          options={dataSituacaoDividaAtiva}
          onChange={onChangeDividaAtiva}
          value={
            dataSituacaoDividaAtiva.filter(value => value.value == filtroDividaAtiva.situacaoDividaAtiva)
              .map(v => { return { value: v.value, label: v.value } })
          }
          invalid={!!errors.situacaoDividaAtiva}
        />
      </Col>

      <Col md={12} lg={3}>
        <TextField
          type={"date"}
          name={"dataInicial"}
          label={"Data Inicial"}
          onChange={onChange}
          value={filtroDividaAtiva.dataInicial}
        />
      </Col>
      <Col md={12} lg={3}>
        <TextField
          type={"date"}
          name={"dataFinal"}
          label={"Data Final"}
          onChange={onChange}
          value={filtroDividaAtiva.dataFinal}
        />
      </Col>
      <Col md={12} lg={6}>
        <TextField
          type={"select"}
          name={"tipoFiscalizacao_Ids"}
          label={"* Tipo de Fiscalização"}
          multiple
          options={listTipoDeFiscalizacao}
          onChange={onChangeMultiSelectDividaAtiva}
          value={listTipoDeFiscalizacao.filter(value => (filtroDividaAtiva.tipoFiscalizacao_Ids ?? []).includes(value.value))}
          invalid={!!errors.tipoFiscalizacao_Ids}
        />
      </Col>
      <Col md={12} lg={6}>
        <TextField
          type={"text"}
          name={"numeroInfracao"}
          label={"Número da infração"}
          onChange={onChange}
          value={filtroDividaAtiva.numeroInfracao}
        />
      </Col>
      <Col md={12} lg={3}>
        <TextField
          type={"text"}
          name={"nome"}
          label={"Nome"}
          onChange={onChange}
          value={filtroDividaAtiva.nome}
        />
      </Col>


      <Col md={12} lg={3}>
        <TextField
          type={"text"}
          name={"bairro"}
          label={"Bairro"}
          onChange={onChange}
          value={filtroDividaAtiva.bairro}
        />
      </Col>
      <Col md={12} lg={4}>
        <TextField
          type={"text"}
          name={"logradouro"}
          label={"Logradouro"}
          onChange={onChange}
          value={filtroDividaAtiva.logradouro}
        />
      </Col>
      <Col md={12} lg={2}>
        <TextField
          type={"text"}
          name={"numero"}
          label={"Numero"}
          mask={mascaras.numeroMask}
          onChange={onChange}
          value={filtroDividaAtiva.numero}
        />
      </Col>

      <Col md={12} lg={2}>
        <Button
          className='w-100 fw-bold mt-2'
          color='info text-light'
          onClick={handleFiltroDividaAtiva}>Gerar Relatório</Button>
      </Col>
    </Row>
  </Card>;
}
